import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddOrRemoveRolesToUserRequest, UserRoleDTO } from '../../../interfaces/user.interface';
import { RoleSummaryDTO } from '../../../interfaces/roles.interfaces';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-assign-user-roles',
  templateUrl: './assign-user-roles.component.html',
  styleUrls: ['./assign-user-roles.component.scss']
})
export class AssignUserRolesComponent implements OnInit {

  @Input()
  public userRoles: Array<UserRoleDTO>;

  @Input()
  public roles: Array<RoleSummaryDTO>;

  public rolesAvailable: Array<RoleSummaryDTO>;

  @Output()
  public rolesToAssign = new EventEmitter<Array<number> | null>;

  public formGroup: FormGroup;

  constructor(private fb: FormBuilder) {

    this.rolesAvailable = new Array<RoleSummaryDTO>;
    this.formGroup = this.fb.group({
      selectedRoles: [null]
    });
  }

  ngOnInit(): void {
    this.rolesAvailable = this.roles.filter(r => !this.userRoles.some(u => u.roleId === r.roleId));
  }

  public cancel()
  {
    this.rolesToAssign.emit(null);
  }

  public submit(){
    const { selectedRoles } = this.formGroup.value;
    const rolesId: Array<number> | null = selectedRoles;
    this.rolesToAssign.emit(rolesId);
  }
}
